import kvstore from './kvstore';

const createViews = () => {
  return {
    read: async (options) => {
      try {
        const response = await kvstore.read({
          component: options?.component || 'dsaComponent',
          userId: options?.userId
        });

        // If we get data back, return it in the expected format
        if (response?.data?.val) {
          return { data: { val: response.data.val } };
        }

        // If no data (404 or empty), return empty array
        return { data: { val: [] } };
      } catch (error) {
        console.error('Views API read error:', error);
        return { data: { val: [] } };
      }
    },

    update: async (options) => {
      try {
        const response = await kvstore.update({
          component: options?.component || 'dsaComponent',
          userId: options?.userId,
          data: options?.data
        });

        // Return the data in the expected format
        if (response?.data) {
          return { data: { val: options?.data } };
        }

        return { data: { val: options?.data } };
      } catch (error) {
        console.error('Views API update error:', error);
        throw error;
      }
    }
  }
};

const singleton = createViews();
Object.freeze(singleton);

export default singleton;
